import { queryOne, queryAll } from '../core/dom.js';

const VIEW_IDS = [
  'gamePicker',
  'modePicker',
  'roomLobby',
  'sidePicker',
  'tycoonSeatPicker',
  'gameScreen',
  'tycoonScreen'
];

export function activateView(viewId) {
  for (const id of VIEW_IDS) queryOne('#' + id)?.classList.add('hidden');
  queryOne('#' + viewId)?.classList.remove('hidden');

  const isGameView = viewId === 'gameScreen' || viewId === 'tycoonScreen';
  queryOne('#statusCard')?.classList.toggle('hidden', !isGameView);
  queryOne('#homeBtn')?.classList.toggle('hidden', viewId === 'gamePicker');
  return { isGameView };
}

export function renderModeCapabilities(game) {
  if (!game) return;

  queryAll('[data-mode]').forEach(button => {
    const mode = button.dataset.mode;
    const supported = game.modes.includes(mode);
    button.disabled = !supported;
    button.classList.toggle('is-disabled', !supported);
    button.setAttribute('aria-disabled', supported ? 'false' : 'true');

    const small = button.querySelector('small');
    if (!small) return;
    if (!small.dataset.defaultCopy) small.dataset.defaultCopy = small.textContent;

    if (supported) {
      small.textContent = game.modeCopy?.[mode] || small.dataset.defaultCopy;
    } else if (mode === 'online') {
      small.textContent = 'Chưa mở Online cho trò này · Protocol hiện tại chỉ dành cho game 2 phe';
    } else {
      small.textContent = 'Chế độ này chưa áp dụng cho trò chơi đã chọn';
    }
  });
}
